const SUCCESS_MSG = 'Cập nhật thành công';

export { SUCCESS_MSG };
